/**
 * Pure helpers: map Oshar tier catalog items (from GET /api/oshar-real-estate/tiers via
 * mapPublicOsharTierDtoToAssetType) into values used by OsharRealEstatePurchaseCard.
 * tierSlug must remain the backend canonical slug (e.g. commercial-storefronts).
 */

export function formatOsharTierUsd(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

/** Remaining sellable units; prefers API `remaining`, else falls back to supply (not 0 unless sold out). */
export function getOsharTierRemainingCount(item) {
  if (item?.remaining != null && Number.isFinite(Number(item.remaining))) {
    return Math.max(0, Math.floor(Number(item.remaining)));
  }
  return Math.max(0, Number(item?.supply) || 0);
}

/**
 * Max units user may select for one Stripe session: min(maxPerCheckout, remaining).
 */
export function getOsharTierMaxSelectablePerCheckout(item, remainingCount) {
  const remainingM = Math.max(0, Number(remainingCount) || 0);
  const pc =
    item?.maxPerCheckout != null && Number.isFinite(Number(item.maxPerCheckout))
      ? Math.floor(Number(item.maxPerCheckout))
      : Math.min(50, Math.max(1, remainingM || 1));
  return Math.max(1, Math.min(pc, remainingM || 1));
}

export function clampOsharPurchaseQuantity(raw, maxSelectable) {
  const max = Math.max(1, Number(maxSelectable) || 1);
  const n = parseInt(String(raw), 10);
  const base = Number.isInteger(n) && n >= 1 ? n : 1;
  return Math.min(max, base);
}

export function getOsharTierSlugForCheckout(item) {
  return String(item?.tierSlug || item?.id || "").trim();
}
